import { Link } from 'react-router-dom';
import { Brain, Lock } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-[#09090B] bg-zinc-50 mt-16" data-testid="site-footer">
      <div className="container-swiss py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Brain className="w-5 h-5 text-[#09090B]" />
              <span className="font-bold text-sm tracking-widest uppercase" style={{ fontFamily: 'Outfit, sans-serif' }}>
                FOKYES
              </span>
            </div>
            <p className="text-xs text-zinc-500 leading-relaxed">
              Measurable cognitive training in 1-hour sessions.
              BrainMap Score is an educational tool, not a medical or diagnostic assessment.
            </p>
          </div>

          <div>
            <h4 className="mono-data text-xs text-[#09090B] mb-3">Product</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/programs" className="text-zinc-700 hover:text-[#09090B]">Programs</Link></li>
              <li><Link to="/marketplace" className="text-zinc-700 hover:text-[#09090B]">Marketplace</Link></li>
              <li><Link to="/pricing" className="text-zinc-700 hover:text-[#09090B]">Pricing</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mono-data text-xs text-[#09090B] mb-3">For Parents</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/parent" className="text-zinc-700 hover:text-[#09090B]">Parent Dashboard</Link></li>
              <li><Link to="/brainmap" className="text-zinc-700 hover:text-[#09090B]">BrainMap Score</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mono-data text-xs text-[#09090B] mb-3">Legal</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/privacy" className="text-zinc-700 hover:text-[#09090B]" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-zinc-700 hover:text-[#09090B]" data-testid="footer-terms">Terms of Service</Link></li>
              <li><a href="mailto:privacy@storytellercharles.com" className="text-zinc-700 hover:text-[#09090B]">Data Requests</a></li>
            </ul>
          </div>
        </div>

        {/* Security disclaimer strip */}
        <div className="border-t border-zinc-200 mt-8 pt-5" data-testid="footer-security">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-3">
            <div className="flex items-center gap-2 flex-shrink-0">
              <Lock className="w-3 h-3 text-[#09090B]" />
              <span className="mono-data text-[10px] text-[#09090B]">Website Security</span>
            </div>
            <p className="text-[11px] text-zinc-600 leading-relaxed">
              Encrypted end-to-end over HTTPS (TLS 1.3). Personal data stored in access-controlled, region-restricted databases with regular integrity checks. We never sell user data. Children&apos;s data collection follows strict verifiable-parental-consent (VPC) rules. Report a security concern to <a href="mailto:security@storytellercharles.com" className="text-[#09090B] underline hover:no-underline">security@storytellercharles.com</a>.
            </p>
          </div>
        </div>

        {/* Attribution + rebrand credit */}
        <div className="border-t border-zinc-200 mt-4 pt-4" data-testid="footer-attribution">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-[11px] text-zinc-600">
            <div>
              <p className="mono-data text-[9px] text-zinc-400 mb-1">Original concept</p>
              <a href="https://godwinsureah.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#09090B]" data-testid="footer-original-concept">
                godwinsureah.com →
              </a>
            </div>
            <div>
              <p className="mono-data text-[9px] text-zinc-400 mb-1">Formerly</p>
              <span data-testid="footer-rebrand-note">in3600seconds · rebranded to FOKYES</span>
            </div>
            <div>
              <p className="mono-data text-[9px] text-zinc-400 mb-1">Powered by</p>
              <span className="font-semibold" data-testid="footer-powered-by">GdoubleU Foundation</span>
            </div>
          </div>
        </div>

        <div className="border-t border-zinc-200 mt-4 pt-4 flex flex-col md:flex-row justify-between items-center gap-2">
          <p className="text-xs text-zinc-500">© {new Date().getFullYear()} FOKYES. All rights reserved.</p>
          <p className="mono-data text-[10px] text-zinc-400">DPDP • COPPA • GDPR-K compliant</p>
        </div>
      </div>
    </footer>
  );
}

